var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.catalogs),function(catalog){return _c('div',{key:catalog.id,staticClass:"d-flex align-items-center py-2 border-bottom",class:{
      selected: _vm.enabledCatalogs[catalog.id],
    }},[_c('Checkbox',{attrs:{"value":_vm.enabledCatalogs[catalog.id]},on:{"update:value":function($event){_vm.$set(_vm.enabledCatalogs, catalog.id, $event); _vm.emit()}}}),_c('div',{staticClass:"flex-grow-1"},[_vm._v(" "+_vm._s(catalog.name)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }